import React, { Component } from 'react'
import { Col, Row } from 'antd';
import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig();

export default class InfoClient extends Component {

    render() {
        const { t, order, infoClient, configClient } = this.props
        const filename = ( configClient && configClient.imageFileName ) ? configClient.imageFileName : null
        const urlImg = `${publicRuntimeConfig.logoImagesBasePath}${filename}`

        return (
            infoClient &&
            <Row>
                <Col span={20}>
                    <Row>
                        <Col>
                            <h4>{t('Client')}</h4>
                        </Col>

                    </Row>
                    <Row>
                        <Col span={6}>
                            <b>{t('Name')}</b>
                        </Col>
                        <Col span={6} >
                            {infoClient.nombre}
                        </Col>
                    </Row>
                    <Row>
                        <Col span={6}>
                            <b>{t('Email')}</b>
                        </Col>
                        <Col span={15} >
                            {infoClient.email}
                        </Col>
                    </Row>
                    <Row>
                        <Col span={6}>
                            <b>{t('Phone')}</b>
                        </Col>
                        <Col span={15} >
                            {infoClient.telefono}
                        </Col>
                    </Row>
                    <Row>
                        <Col span={6}>
                            <b>{t('Address')}</b>
                        </Col>
                        <Col span={15} >
                            {infoClient.domicilio}
                        </Col>
                    </Row>
                    <Row>
                        <Col span={6}>
                            <b>{t('Location')}</b>
                        </Col>
                        <Col span={15} >
                            {infoClient.nombrelocalidad}
                        </Col>
                    </Row>
                    <Row>
                        <Col span={6}>
                            <b>{t('Province')}</b>
                        </Col>
                        <Col span={15} >
                            {infoClient.nombreprovincia}
                        </Col>
                    </Row>
                </Col>
                { filename && <Col span={4} style={{paddingTop:'20px'}} >
                    <img width={'50%'} src={ urlImg } />
                </Col>}
            </Row>
            || null
        )
    }
}
